import { render, staticRenderFns } from "./BudgetReports.vue?vue&type=template&id=4957d574"
import script from "./BudgetReports.vue?vue&type=script&lang=js"
export * from "./BudgetReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports